import './qrScanner.css';
import QrScanner from "qr-scanner";
import { ReactNode, useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { FlashlightIcon } from '../../assets/icons/FlashlightIcon';

interface QrCodeScannerProps {
    onDecode: (result: string) => void
}

// https://github.com/nimiq/qr-scanner
const QrCodeScanner = ({ onDecode }: QrCodeScannerProps): ReactNode => {
    const [qrScannerHasFlash, setQrScannerHasFlash] = useState<boolean>(false);
    const [isFlashOn, setFlashOn] = useState<boolean>(false);
    const [cameras, setCameras] = useState<QrScanner.Camera[]>([]);

    const videoRef = useRef<HTMLVideoElement>(null);
    const selectRef = useRef<HTMLSelectElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (!videoRef.current) {
            console.warn("QrCodeScanner: Failed to reference video element");
            return;
        }

        const qrScanner = new QrScanner(
            videoRef.current,
            (result: QrScanner.ScanResult) => {
                onDecode(result.data);
            },
            {
                highlightScanRegion: true,
            }
        );

        qrScanner.start().then(() => {
            console.log('scan started')
        });

        qrScanner.hasFlash().then((result) => {
            setQrScannerHasFlash(result);
        });

        if (buttonRef.current) {
            buttonRef.current.addEventListener('click', () => {
                qrScanner.toggleFlash().then(() => {
                    setFlashOn(qrScanner.isFlashOn());
                });
            });
        }
        else {
            console.warn("QrCodeScanner: Failed to query button element");
        }

        QrScanner.listCameras(true).then((cameras) => {
            setCameras(cameras);
        });

        if (selectRef.current) {
            selectRef.current.addEventListener('change', (e: Event) => {
                const select = e.currentTarget as HTMLSelectElement;
                if (!select) {
                    console.warn("QrCodeScanner: reference to invalid select element");
                    return;
                }
                qrScanner.setCamera(select.value).then(() => {
                    qrScanner.hasFlash().then((result) => {
                        setQrScannerHasFlash(result);
                    })
                });
            })
        } else {
            console.warn("QrCodeScanner: Failed to reference select element");
        }

        return () => {
            qrScanner.stop();
            qrScanner.destroy()
        }
    }, [onDecode]);

    console.log(cameras);

    return (
        <>
            <video ref={videoRef}></video>
            <div className={'actionsContainer'}>
                <Button ref={buttonRef} variant={'light'} hidden={!qrScannerHasFlash}>
                    <FlashlightIcon state={isFlashOn} />
                </Button>

                <select ref={selectRef} className={'form-select'}>
                    {cameras.map((item) => (
                        <option key={item.id} value={item.id}>{item.label}</option>
                    ))}
                </select>
            </div>
        </>
    );
};

export default QrCodeScanner;